import { useQuery } from 'react-query';
import { fileService } from 'services';

const PdfViewer = ({ objectKey }: { objectKey: string }) => {
  const { data: url, isSuccess } = useQuery(['fileService.downloadFile', { key: objectKey }], () =>
    fileService
      .downloadFile(objectKey)
      .then((data) => window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))),
  );

  return (
    <div className='border' style={{ height: 'calc(-180px + 80vh)' }}>
      {isSuccess && <embed className='w-full h-full' src={url} />}
    </div>
  );
};

export default PdfViewer;
